"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalEntityEnum = void 0;
var LegalEntityEnum;
(function (LegalEntityEnum) {
    LegalEntityEnum["ON_AG"] = "onag";
    LegalEntityEnum["ON_AU"] = "onau";
    LegalEntityEnum["ON_BR"] = "onbr";
    LegalEntityEnum["ON_CA"] = "onca";
    LegalEntityEnum["ON_CN"] = "oncn";
    LegalEntityEnum["ON_HK"] = "onhk";
    LegalEntityEnum["ON_JP"] = "onjp";
    LegalEntityEnum["ON_KR"] = "onkr";
    LegalEntityEnum["ON_UK"] = "onuk";
    LegalEntityEnum["ON_US"] = "onus";
})(LegalEntityEnum = exports.LegalEntityEnum || (exports.LegalEntityEnum = {}));
//# sourceMappingURL=legal-entity.enum.js.map